/*
 * @Author: cc
 * @LastEditTime: 2021-10-25 16:33:16
 */
/*
 * @Author: cc
 * @LastEditTime: 2021-05-27 13:40:25
 */
// import React, { useEffect, useState } from "react";
import { HashRouter, Switch, Route, BrowserRouter } from "react-router-dom";
import Index from "../page/pcHome/index";
import Play from "../page/play/play";
import Project from "@/page/pcHome/newProject/index";
import Header from "../page/component/header"
// import Login from "../page/component/login"
import Recommend from "../page/pcHome/recommend"
import MobileHome from "../page/mobileHome"
import MobileProject from "../page/mobileHome/project"
import MobileHeader from "../page/mobileHome/component/header"
import SignUp from "src/page/mobileHome/signup";
import MobileRecommend from "src/page/mobileHome/recommend"
import MobileLogin from "src/page/mobileHome/login"
import WxSubscript from "src/page/component/wxSubscript"
import CertificateView from "src/page/component/certificateView"
import Pdf from "src/page/mobileHome/pdf"
import { isInApp, webCallApp,isInHarmonyOS } from "src/utils/web-call-app";
// import store from "src/reducers";
import { IsPc } from "../utils";
import "./index.scss"

// import { post } from "src/component/fetch";
export const pcRouter = [
  {
    path: "/index",
    component: Index,
    isHeader: true,
    notNeedLogin: true,
  },
  {
    path: "/project",
    component: Project,
    isHeader: true,
  },
  {
    path: "/play",
    component: Play,
    isHeader: true,
  },
  {
    path: "/recommend/:contentId",
    component: Recommend,
    isHeader: false,
  },
  {
    path: "/wxSubscript",
    component: WxSubscript,
    isHeader: true,
    title: "微信扫一扫,关注服务号"
  },
  {
    path: "/certificateView",
    component: CertificateView,
    isHeader: false,
    title: "证书预览"
  },
  {
    path: "*",
    component: Index,
    isHeader: true,
    notNeedLogin: true,
  },
];
export const mobileRouter = [
  {
    path: "/index",
    component: MobileHome,
    isHeader: true,
    name:"首页"
    // notNeedLogin:true
  },
  {
    path:"/login",
    component:MobileLogin,
    isHeader:true,
     title: "登录注册"
  },
  {
    path: "/project",
    component: MobileProject,
    isHeader: true,
    title: "主题详情"
  },
  {
    path: "/play",
    component: Play,
    isHeader: true,
  },
  {
    path: "/recommend/:contentId",
    component: MobileRecommend,
    isHeader: true,
    title: "推荐内容"
  },
  {
    path: "/signUp",
    component: SignUp,
    isHeader: true,
    title: "报名页"
  },
  {
    path: "/wxSubscript",
    component: WxSubscript,
    isHeader: true,
    title: "微信扫一扫,关注服务号"
  },
  {
    path: "/certificateView",
    component: CertificateView,
    isHeader: false,
    title: "证书预览"
  },
  {
    path: "/pdf",
    component: Pdf,
    isHeader: false,
    title: "pdf"
  },
  {
    path: "*",
    component: MobileHome,
    isHeader: true,
    title:"首页"
    // notNeedLogin:true,
  },
]
function RouteWithSubRoutes(route) {
  return (
    <>
      <Route
        path={route.path}
        render={(props) => (
          <>
            {/* {
              !route.notNeedLogin && getUserInfo()
            } */}
            {/* {route.isHeader && IsPc() && <Header></Header>} */}
            {route.isHeader && !IsPc() && !isInApp() && !isInHarmonyOS() && <MobileHeader {...props}  {...route}></MobileHeader>}
            <route.component {...props} routes={route.routes} />
           
            {/* <Login open={loginView} onOk={() => {
              window.location.reload()
            }} onCancel={() => setLoginView(false)}></Login> */}
          </>
        )}
      />
    </>
  );
}
let RouteConfigExample = (props) => {
  const routes = IsPc() ? pcRouter : mobileRouter
  return (
    <HashRouter>
      <div className={isInHarmonyOS() ? "wrapper pb20" : "wrapper"} >
        <Switch>
          {routes.map((route, i) => (
            <RouteWithSubRoutes key={i} {...route} />
          ))}
        </Switch>
      </div>
    </HashRouter>
  );
};
export default RouteConfigExample;
